import { common } from './common';
import { room } from './room';

export const translation = {
  common,
  room,
};
